export default __webpack_public_path__ + "static/news18-636d19e858692b12a4cc6aa7ec8aabb6.jpeg";